import { Link } from 'react-router-dom';

export function SiteFooter() {
  return (
    <footer data-site-footer className="border-t border-[var(--border-subtle)] py-14">
      <div className="container-page">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="grid size-9 place-items-center overflow-hidden rounded-xl bg-clay-500 text-base text-white">
                <img src="/assets/travessa-mark.png" alt="" className="size-full object-cover" />
              </span>
              <span className="display text-2xl">Travessa</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-[var(--text-muted)]">
              Планировщик путешествий: маршрут по дням, карта, фотографии с геометками и
              AI-помощник. Приватность настраиваете вы.
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-12 gap-y-8 text-sm sm:grid-cols-3">
            <FooterColumn
              title="Продукт"
              links={[
                { to: '/gallery', label: 'Витрина маршрутов' },
                { to: '/deals', label: 'Выгодные предложения' },
                { to: '/#how', label: 'Как это работает' },
                { to: '/#ai', label: 'AI-планировщик' },
                { to: '/#privacy', label: 'Приватность' },
              ]}
            />
            <FooterColumn
              title="Аккаунт"
              links={[
                { to: '/login', label: 'Войти' },
                { to: '/register', label: 'Регистрация' },
                { to: '/app', label: 'Мои путешествия' },
              ]}
            />
            <FooterColumn
              title="Данные"
              links={[
                { to: '/privacy', label: 'Что мы храним' },
                { to: '/recover', label: 'Восстановить доступ' },
              ]}
            />
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-[var(--border-subtle)] pt-6 text-xs text-[var(--text-muted)] sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Travessa</span>
          <span>Карты — Яндекс и Google · Аккаунты без персональных данных</span>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  links,
}: {
  title: string;
  links: Array<{ to: string; label: string }>;
}) {
  return (
    <div>
      <div className="eyebrow mb-4">{title}</div>
      <ul className="space-y-2.5">
        {links.map((link) => (
          <li key={link.to + link.label}>
            <Link
              to={link.to}
              className="link-underline text-[var(--text-muted)] transition-colors hover:text-[var(--text-strong)]"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
